import { render, staticRenderFns } from "./star-rating-component.vue?vue&type=template&id=6d858f1c&scoped=true&"
import script from "./star-rating-component.vue?vue&type=script&lang=ts&"
export * from "./star-rating-component.vue?vue&type=script&lang=ts&"
import style0 from "./star-rating-component.vue?vue&type=style&index=0&id=6d858f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d858f1c",
  null
  
)

export default component.exports